export default "__VITE_ASSET__D4ARkQr6__"